var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-tabs',{attrs:{"content-class":"mt-2","justified":""}},[_c('b-tab',{attrs:{"active":"","title":"Page"}},[_c('Page')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }